<template>
  <div class="container">
    <div style="margin: 10px; margin-bottom: 20px;">
      <div class="row">
        <div class="coi-sm">
          <div v-if="errors.length" class="alert alert-danger" role="alert">
            <ul>
              <li v-for="error in errors" v-bind:key="error" class="text-start">
                {{error}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row" style="text-align: left">
        <div class="form-group">
          <label for="firtsName">Vorname</label>
          <input
            v-model="user.firstName"
            type="text"
            class="form-control"
            id="firtsName"
            placeholder="Vorname"
            required
          >
        </div>
        <div class="form-group">
          <label for="lastName">Nachname</label>
          <input
            v-model="user.lastName"
            type="text"
            class="form-control"
            id="lastName"
            placeholder="Nachname"
            required
          >
        </div>
        <div class="form-group">
          <label for="email">Email address</label>
          <input
            v-model="user.email"
            type="email"
            class="form-control"
            id="name"
            aria-describedby="emailHelp"
            placeholder="Email"
            required
          >
        </div>
        <div class="form-group">
          <label for="street">Straße</label>
          <input
            v-model="user.street"
            type="text"
            class="form-control"
            id="street"
            placeholder="Straße"
            required
          >
        </div>
        <div class="form-group">
          <label for="hNr">Hausnummer</label>
          <input
            v-model="user.hNr"
            type="text"
            class="form-control"
            id="hNr"
            placeholder="Hausnummer"
            required
          >
        </div>
        <div class="form-group">
          <label for="plz">PLZ</label>
          <input
            v-model="user.plz"
            type="text"
            class="form-control"
            id="plz"
            placeholder="PLZ"
            required
          >
        </div>
        <div class="form-group">
          <label for="city">Stadt</label>
          <input
            v-model="user.city"
            type="text"
            class="form-control"
            id="city"
            placeholder="Stadt"
            required
          >
        </div>
        <div class="form-group">
          <label for="country">Land</label>
          <input
            v-model="user.country"
            type="text"
            class="form-control"
            id="country"
            placeholder="Land"
            required
          >
        </div>
        <div class="form-group">
          <label for="country">Telefonnummer</label>
          <input
            v-model="user.phone"
            type="text"
            class="form-control"
            id="phone"
            placeholder="Telefonnummer"
            required
          >
        </div>
        <div class="row rounded rounded-5 border border-dark p-5">
          <div class="col-sm-7">
            <h5>Die zu buchenden Leistungen</h5>
            <ul class="text-start">
              <li v-for="service in services" v-bind:key="service">{{ service }}</li>
            </ul>
          </div>
          <div class="col-sm">
            <h5>Die Gebühr für die gesamte Leistung beträgt:</h5>
            <h3><b>{{total}}€</b></h3>
          </div>
        </div>
        <button class="btn btn-dark" v-on:click="save">Bezahlen mit Paypal</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '../entities/User'
import { Appointment } from '../entities/Appointment'
import { Course } from '@/entities/Course'

@Component
export default class UserForm extends Vue {
  @Prop() private readonly type!:string
  @Prop({ default: () => User.emptyUser() }) private readonly user!: User
  private selectedAppointments:Appointment[] = []

  private errors:string[] = []

  private course:Course = Course.emptyCourse()

  isValid (user: User) {
    this.errors = []
    if (user.firstName === '') {
      this.errors.push('Die Angabe des Vornamens ist erforderlich')
    }

    if (user.lastName === '') {
      this.errors.push('Die Angabe des Nachnamens ist erforderlich')
    }

    if (user.email === '') {
      this.errors.push('Die Angabe der Email ist erforderlich')
    }
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    if (!emailRegex.test(user.email)) {
      this.errors.push('Die E-Mail-Adresse ist ungültig')
    }

    if (user.street === '') {
      this.errors.push('Die Angabe der Straße ist erforderlich')
    }

    if (user.hNr === '') {
      this.errors.push('Die Angabe der Hausnummer ist erforderlich')
    }

    if (user.plz === '') {
      this.errors.push('Die Angabe der PLZ ist erforderlich')
    }

    if (user.city === '') {
      this.errors.push('Die Angabe der Stadt ist erforderlich')
    }

    if (user.country === '') {
      this.errors.push('Die Angabe des Landes ist erforderlich.')
    }

    if (user.phone === '') {
      this.errors.push('Die Angabe der Telefonnumer ist erforderlich.')
    }

    return !this.errors.length
  }

  async save () {
    if (this.isValid(this.user)) {
      this.$emit('userFilled', this.user)

      const data = {
        client: this.user,
        appointments: this.selectedAppointments,
        total: this.total
      }

      console.log(data)

      try {
        const res = await Vue.axios.post('/paypal/createOrder', data).then()
        // STEP 4: Redirect user to PayPal approval link
        window.location.href = res.data.approvalUrl
      } catch (error) {
        console.log(error)
        this.$router.push({ name: 'reservation_failed' })
      }
    }
  }

  get total () {
    let total = 0.0
    this.selectedAppointments = this.$store.getters.getSelectedAppointments()
    this.selectedAppointments.forEach((appointment, index) => {
      this.course = this.$store.getters.getCouseById(appointment.courseId)
      total += this.course.price
    })
    return total
  }

  get services () {
    const services:string[] = []
    this.selectedAppointments = this.$store.getters.getSelectedAppointments()
    this.selectedAppointments.forEach((appointment, index) => {
      this.course = this.$store.getters.getCouseById(appointment.courseId)
      services.push(this.course.name + ' : ' + appointment.begin.toLocaleDateString())
    })
    return services
  }
}
</script>

<style scoped>

</style>
